import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';

interface DailyEstimateCardProps {
  liveBirds: number;
}

export const DailyEstimateCard: React.FC<DailyEstimateCardProps> = ({
  liveBirds,
}) => {
  const { t } = useTranslation();
  const estimate = Math.round(liveBirds * 0.06);

  return (
    <Card className="p-4 bg-info/10 border-info/30">
      <div className="flex items-center gap-3">
        <span className="text-3xl">💡</span>
        <div>
          <p className="font-medium text-foreground">
            {t('cbs.feed.dailyEstimate')}
          </p>
          <p className="text-sm text-muted-foreground">
            {t('cbs.feed.estimateDesc', { birds: liveBirds, estimate })}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default DailyEstimateCard;
